@if (shouldShow()) {
  <div class="version-update-notification alert alert-warning fade show mb-0" role="alert">
    <div class="d-flex align-items-center">
      <div class="flex-grow-1">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        <strong>New version available!</strong>
        A new version of the application is available. Please reload to get the latest updates.
        <small class="d-block mt-1 text-muted">The page will automatically reload in 5 minutes if you don't reload manually.</small>
      </div>
      <div class="ms-3">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          (click)="onReload()">
          <i class="bi bi-arrow-clockwise me-1"></i>
          Reload Now
        </button>
      </div>
    </div>
  </div>
}
